/**
 * LinkButton — text-style button for in-table / in-text navigation
 * (replaces `<button className="catalogue-name">` style ad-hoc links).
 */
export default function LinkButton({
  children,
  onClick,
  type = 'button',
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      className={`link-button ${className}`.trim()}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}
